import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[panelExtraHeader]',
})
export class PanelExtraHeader {
  constructor(public templateRef: TemplateRef<any>) {}
}
